(function () {
  const STORAGE_KEY = 'recent';

  function normalizeUrl(url) {
    try {
      const u = new URL(url);
      u.search = '';
      u.hash = '';
      u.pathname = u.pathname.replace(/\/+$/, '');
      return u.toString();
    } catch {
      return url.split('?')[0].split('#')[0].replace(/\/+$/, '');
    }
  }

  function loadData() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || { collections: [], products: [] };
    } catch {
      return { collections: [], products: [] };
    }
  }

  function saveData(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function mergeByUrl(items, urlKey, viewsKey, lastVisitKey) {
    const map = new Map();
    for (const item of items) {
      const normalized = normalizeUrl(item[urlKey]);
      if (map.has(normalized)) {
        const existing = map.get(normalized);
        existing[viewsKey] += item[viewsKey];
        if (new Date(item[lastVisitKey]) > new Date(existing[lastVisitKey])) {
          existing[lastVisitKey] = item[lastVisitKey];
        }
      } else {
        map.set(normalized, { ...item, [urlKey]: normalized });
      }
    }
    return Array.from(map.values()).sort((a, b) => new Date(b[lastVisitKey]) - new Date(a[lastVisitKey]));
  }

  function maybeNormalise(data) {
    const now = new Date();
    const last = data.normalised ? new Date(data.normalised) : null;
    const due = !last || (now - last) >= 7 * 24 * 60 * 60 * 1000;

    if (!due) return data;

    data.collections = mergeByUrl(data.collections, 'collection_url', 'collection_views', 'collection_last_visit');
    data.products = mergeByUrl(data.products, 'product_url', 'product_views', 'product_last_visit');
    data.normalised = now.toISOString();

    saveData(data);
    console.log('[recent] normalised', data);
    return data;
  }

  function trackCollection(data) {
    const el = document.querySelector('.section-heading h1');
    if (!el) return;

    const url = normalizeUrl(window.location.href);
    const now = new Date().toISOString();
    const existing = data.collections.find(c => normalizeUrl(c.collection_url) === url);

    if (existing) {
      existing.collection_views += 1;
      existing.collection_last_visit = now;
      existing.collection_url = url;
    } else {
      data.collections.unshift({
        collection_name: el.textContent.trim(),
        collection_url: url,
        collection_views: 1,
        collection_last_visit: now,
      });
    }

    data.collections.sort((a, b) => new Date(b.collection_last_visit) - new Date(a.collection_last_visit));

    saveData(data);
    console.log('[recent]', data);
  }

  function trackProduct(data) {
    const nameEl = document.querySelector('h1.product__title');
    if (!nameEl) return;

    const imgEl = document.querySelector('.product-gallery-item figure img');
    const productId = document.querySelector('product-page[data-id]')?.getAttribute('data-id') || null;
    const sellingPoints = Array.from(document.querySelectorAll('.product-selling-points li.product-selling-points__item span'))
      .slice(0, 2)
      .map(el => el.textContent.trim());

    const url = normalizeUrl(window.location.href);
    const now = new Date().toISOString();
    const existing = data.products.find(p => normalizeUrl(p.product_url) === url);

    if (existing) {
      existing.product_views += 1;
      existing.product_last_visit = now;
      existing.product_url = url;
      existing.product_selling_points = sellingPoints;
    } else {
      data.products.unshift({
        product_name: nameEl.textContent.trim(),
        product_url: url,
        product_id: productId,
        product_img: imgEl ? imgEl.src : null,
        product_selling_points: sellingPoints,
        product_views: 1,
        product_last_visit: now,
      });
    }

    data.products.sort((a, b) => new Date(b.product_last_visit) - new Date(a.product_last_visit));

    saveData(data);
    console.log('[recent]', data);
  }

  const data = maybeNormalise(loadData());
  const path = window.location.pathname;

  if (path.includes('/collections/')) trackCollection(data);
  else if (path.includes('/products/')) trackProduct(data);

})();